(() => {
  if (customElements.get('scar-v5-mechanism')) return;
  customElements.define('scar-v5-mechanism', class extends HTMLElement {
    connectedCallback() {
      this.elapsed = 0;
      this.svg = this.querySelector('svg');
      this.shapes = Array.from(this.querySelectorAll('[data-v5m-shape]'));
      this.mobile = window.matchMedia('(max-width: 650px)');
      this.fitDiagram = () => this.svg?.setAttribute('viewBox', this.mobile.matches ? '60 0 480 370' : '0 0 600 370');
      this.mobile.addEventListener('change', this.fitDiagram);
      this.fitDiagram();
      this.inView = false;
      this.lastTime = null;
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.staticFallback = !!this.closest('.v5-static-mechanism');
      this.tick = this.tick.bind(this);
      this.sync = this.sync.bind(this);
      this.preference.addEventListener('change', this.sync);
      document.addEventListener('visibilitychange', this.sync);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: .08 });
        this.observer.observe(this);
      } else this.inView = true;
      this.classList.add('is-ready');
      this.sync();
    }
    // Only the explanatory contour changes. It never reaches flat skin height.
    // The covering follows the skin; it does not push down on it.
    drawRemodeling(progress) {
      const p = Math.max(0, Math.min(1, progress));
      const lift = 18 * p;
      const n = value => (value + lift).toFixed(2);
      const contour = (x, y, top, end) => `M${x} ${y}H205C244 ${y} 242 ${n(top)} 300 ${n(top)}S356 ${y} 395 ${y}H${end}`;
      const paths = {
        skin: contour(30,230,174,570) + 'V329H30Z',
        surface: contour(30,230,174,570),
        hydration: contour(40,237,181,560),
        layer: contour(43,224,168,557),
        highlight: contour(43,218,162,557)
      };
      this.shapes.forEach(path => path.setAttribute('d', paths[path.dataset.v5mShape]));
    }
    setPhase(phase) {
      if (this.dataset.phase === String(phase)) return;
      this.dataset.phase = phase;
      this.querySelectorAll('[data-v5m-step]').forEach(step => {
        if (step.dataset.v5mStep === String(phase)) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
      const number = this.querySelector('[data-v5m-phase-number]');
      if (number) number.textContent = phase;
    }
    sync() {
      cancelAnimationFrame(this.frame);
      this.lastTime = null;
      const reduced = this.preference.matches || this.staticFallback;
      const wasReduced = this.classList.contains('is-reduced');
      if (wasReduced !== reduced) this.elapsed = 0;
      this.classList.toggle('is-reduced', reduced);
      this.running = !reduced && this.inView && !document.hidden;
      this.style.setProperty('--v5m-play', this.running ? 'running' : 'paused');
      if (reduced) { this.setPhase(2); this.drawRemodeling(0); }

      if (this.running) this.frame = requestAnimationFrame(this.tick);
    }
    tick(time) {
      if (!this.running) return;
      if (this.lastTime !== null) this.elapsed += time - this.lastTime;
      this.lastTime = time;
      const cycle = this.elapsed % 12000;
      this.setPhase(Math.floor(cycle / 4000) + 1);
      const t = Math.max(0, Math.min(1, (cycle - 8000) / 2700));
      this.drawRemodeling(t * t * (3 - 2 * t));
      this.frame = requestAnimationFrame(this.tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.fitDiagram);
      this.preference?.removeEventListener('change', this.sync);
      document.removeEventListener('visibilitychange', this.sync);
    }
  });
})();

